import script from "./OrderNow.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderNow.vue?vue&type=script&setup=true&lang=js"

import "./OrderNow.vue?vue&type=style&index=0&id=69b8428e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b8428e"]])

export default __exports__